import React, { useState,useEffect } from "react";
import EcoProButton from "../../../../shared/button/button";
import EcoProOverlayModal from "../../../../shared/modal/OverlayModal/EcoProOverlayModal";
import { useTranslation } from "react-i18next";
import AdminFormInput from "../../../../AdminPortal/Shared/FormElements/FormInput/FormInput";
import { useDispatch, useSelector } from "react-redux";
import { 
    fetchDisconnectBOCOnlineFunctionsServiceRequest, 
    fetchDisconnectBOCOnlineFunctionsServiceReset 
} from "../../../../../store/CSAgentPortal/BOC/DisconnectBOCOnlineFunctionsServiceSlice";
import Loader from "../../../../shared/loader/Loader";
import { SUCCESS } from "../../../../../constants/AppConstants";
import EcoproAlert from "../../../../shared/alert/alert";
import AlertDanger from '../../../../../assets/images/alert-danger.svg'

const DisconnectBOCOnlineFunctionsService = (props) => {
    const { t } = useTranslation("CSAgenttranslation");
    const dispatch = useDispatch();
    const modalPropsInitialState = {
        modal_title: "",
        modal_sub_title: "",
        modal_content: "",
        cancel_btn_text: t("MODAL_BUTTON_TXT.CANCEL"),
        confirm_btn_text: t("MODAL_BUTTON_TXT.CONFIRM"),
        toggleModal: "",
        customClassName: "",
        confirm_btn_onClick: "",
        type: "normal"
    }

    const disconnectBOCOnlineFunctionsServiceResponse = useSelector((state) => state.CSAGENT_RTK.DisconnectBOCOnlineFunctionsService);

    // extract user id form props
    const { userId } = props || {};

    const [modalState, setModalState] = useState(false);
    const [modalType, setModalType] = useState("input");
    const [modalProps, setModalProps] = useState(modalPropsInitialState);
    const [serialNumber, setSerialNumber] = useState(null);
    const [disconnectBOConlineFunctionsState, setDisconnectBOConlineFunctionsState] = useState(false);
    const [diconnectBOCOnlineFunctionsErrorAlertOpen, setDisconnectBOCOnlineFunctionsErrorAlertOpen] = useState(false);

    const toggleModal = (event) => {
        setModalState(!modalState);
    };


    const disconnectBOCOnlineFunctionsService = () => {
        setModalState(false);
        dispatch(fetchDisconnectBOCOnlineFunctionsServiceRequest({ serialNumber, userId }));
        setDisconnectBOConlineFunctionsState(true);
    }

    const modalClose = () => {
        setSerialNumber(null)
        setModalState(false)
    }

    const dismissDiconnectBOCOnlineFunctionsErrorAlert = () => {
        setDisconnectBOCOnlineFunctionsErrorAlertOpen(false);
    }

    const handleNewSerialNumber = () => {
        dispatch(fetchDisconnectBOCOnlineFunctionsServiceReset());
        setModalState(true);
        setModalType("input");
        setSerialNumber(null);
    };

    useEffect(() => {
        if (!modalState) return; 
        if (modalType === "input") {
            setModalProps({
                modal_title: t('CUSTOMER_DASHBOARD.TAB_ITEMS.DISCONNECT_BOC_ONLINEFUNCTIONS_SERVICE'),
                modal_content: (
                    <AdminFormInput
                        id="disconnectbocservice-serialnumber-input"
                        name="disconnectbocservice-serialnumber-input"
                        onChange={(e) => setSerialNumber(e.target.value)}
                        value={serialNumber}
                        isRequired={true}
                        placeholder={t('CUSTOMER_DASHBOARD.DISCONNECT_BOC_SERVICE.ENTER_SERIAL_NUMBER')}
                        type="text"
                        minLength={0}
                        maxLength={100}
                    />
                ),
                cancel_btn_text: t("MODAL_BUTTON_TXT.CANCEL"),
                confirm_btn_text: t("MODAL_BUTTON_TXT.CONFIRM"),
                toggleModal: toggleModal,
                customClassName: "customer-dashboard-swap-modal",
                confirm_btn_onClick: () => disconnectBOCOnlineFunctionsService(),
                type: "normal"
            });
        }
        // eslint-disable-next-line
    }, [serialNumber, modalState, modalType]);

    if (disconnectBOCOnlineFunctionsServiceResponse?.success && disconnectBOConlineFunctionsState) {
        setModalState(true);
        setModalType("result"); 
        const actionStatus = disconnectBOCOnlineFunctionsServiceResponse.DisconnectBOCOnlineFunctionsService.actionStatus;
        const content = disconnectBOCOnlineFunctionsServiceResponse.DisconnectBOCOnlineFunctionsService.actionMessage;
        const modalTitle = actionStatus.toUpperCase() === SUCCESS
            ? t('CUSTOMER_DASHBOARD.DISCONNECT_BOC_SERVICE.DEVICE_DISCONNECTED_SUCCESSFULLY')
            : t('CUSTOMER_DASHBOARD.DISCONNECT_BOC_SERVICE.FAILED_TO_DISCONNECT_DEVICE');
        setModalProps({
            modal_title: modalTitle,
            modal_content: content,
            confirm_btn_text: t("MODAL_BUTTON_TXT.CLOSE"),
            customClassName: "customer-dashboard-swap-modal",
            confirm_btn_onClick: modalClose,
            type: "normal",
        });
        setDisconnectBOConlineFunctionsState(false);
    }

    if (disconnectBOCOnlineFunctionsServiceResponse?.error && disconnectBOConlineFunctionsState) {
        setDisconnectBOCOnlineFunctionsErrorAlertOpen(true);
        setDisconnectBOConlineFunctionsState(false);
    }

    return (
        <div>
            {
                (disconnectBOCOnlineFunctionsServiceResponse.loading) && <Loader setOverlay={true}></Loader>
            }
            {
                (disconnectBOCOnlineFunctionsServiceResponse.error) && diconnectBOCOnlineFunctionsErrorAlertOpen &&
                <EcoproAlert
                    alertImg={AlertDanger}
                    dismissAlert={dismissDiconnectBOCOnlineFunctionsErrorAlert}
                    alertSubHeader={t('CS_AGENT_ERROR_CONTENT.ERR_INFO.TECHNICAL_ERROR')}
                ></EcoproAlert>
            }
            <div className="device-details-btn-wrapper mt-20">
                <EcoProButton btnID="disconnect-bocservice-serialnumber-btn" cname="default" onBtnClick={() => handleNewSerialNumber()}>
                    {t('CUSTOMER_DASHBOARD.DISCONNECT_BOC_SERVICE.DELINK_THE_DEVICE')}
                </EcoProButton>
            </div>
            <EcoProOverlayModal {...modalProps} modal_state={modalState}></EcoProOverlayModal>
        </div>
    );
}

export default DisconnectBOCOnlineFunctionsService;